module.exports = __webpack_public_path__ + "img/Greenfoundation.ff0f0637.png";